// extracted by mini-css-extract-plugin
export default {"stripe-container":"styles__stripe-container--H+L8e","flex-container":"styles__flex-container--Ra59i","center":"styles__center--S++ec"};